
import { useState } from 'react';
import { getToken } from '../tools/utils';

// interface  RemoveOrgManagerParams {
//   organizationId: string;
//   contactId: string;
// }

const useRemoveOrgManager = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const removeOrgManager = async (
    organizationId: string,
  ContactId: string,
  Id: string
  ) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const tokenId = await getToken();
      const { REACT_APP_WEB_API, REACT_APP_HEADERKEY } = process.env;

      const res = await fetch(`${REACT_APP_WEB_API}OrgManager/remove`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenId}`,
          'Content-Type': 'application/json',
           "Head-Key":REACT_APP_HEADERKEY 
        },
        body: JSON.stringify({
         OrganizationId: organizationId,
        ContactId:ContactId,
        Id:Id
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to remove org manager');
      }

      setSuccess(true);
    } catch (err) {
      console.error(err);
      setError('An error occurred while removing the CertWatch request.');
    } finally {
      setIsLoading(false);
    }
  };

  return { removeOrgManager, isLoading, error, success };
};

export default useRemoveOrgManager;
